import {
  array,
  arrayOf,
  func,
  node,
  oneOf,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { Link } from "react-router-dom";

import ObjectInformation from "web/Pages/Checkout/TourismDomestic/SharedComponents/ObjectInformation";

import Image from "web/Layout/Common/Image";
import __ from "web/Layout/Translations";

import DetailsList from "web/Components/Common/ConfigurableDetailsList";

import classify from "web/classify";

import defaultStyles from "./details.scss";

const CheckoutProductDetailsMobile = ({
  name,
  image,
  link,
  classes,
  additionalInfo,
  children,
  dataT1,
  productData,
  variant,
}) => {
  return (
    <div className={classes.root} data-t1={dataT1}>
      <Link
        className={classes.imageBox}
        to={link}
        data-t1="checkout_agreements_link"
      >
        <Image
          src={image}
          className={classes.image}
          alt={name}
          isProduct
          dataT1="details_image"
        />
      </Link>
      <div
        className={classes.content}
        data-t1="checkout_agreements_category_link_wrapper"
      >
        <h2 className={classes.title} data-t1="checkout_agreements_title_link">
          <Link to={link} title={name} data-t1="product_name" data-t2={name}>
            {__(name)}
          </Link>
        </h2>
        {children || null}
        <ObjectInformation product={productData} />
        <DetailsList
          className={classes.details}
          items={additionalInfo}
          dataT1={`${dataT1}_details_list`}
          variant={variant}
        />
      </div>
    </div>
  );
};

CheckoutProductDetailsMobile.propTypes = {
  name: string.isRequired,
  image: oneOfType([string, oneOf([null])]),
  additionalInfo: arrayOf(shape({})),
  classes: shape({}).isRequired,
  productData: shape({}).isRequired,
  link: string.isRequired,
  children: oneOfType([node, string, array, func, shape({}), oneOf([null])]),
  dataT1: string,
};

CheckoutProductDetailsMobile.defaultProps = {
  image: null,
  additionalInfo: [],
  children: null,
  dataT1: "details",
};

export default classify(defaultStyles)(CheckoutProductDetailsMobile);
